import Cloud from './Cloud'
import Domain from './Domain'
import Mlytics from './Mlytics'
import Other from './Other'
import Server from './Server'
import SSL from './SSL'
import SwiftFederation from './SwiftFederation'

const Template = {
    'SwiftFederation.CDN': SwiftFederation.CDN,
    'SwiftFederation.Transcoding': SwiftFederation.Transcoding,
    'SwiftFederation.Recording': SwiftFederation.Transcoding,
    'SwiftFederation.StorageOSS': SwiftFederation.Transcoding,
    'SwiftFederation.StorageLFD': SwiftFederation.Transcoding,
    'SwiftFederation.Transmuxing': SwiftFederation.Transcoding,
    'Cloud.VPS': Mlytics.Vnis, // done
    'Cloud.VCloud': Cloud.VCloud,
    'Email.Server': Mlytics.Vnis, // done
    'Email.EGPlatform': Mlytics.Vnis, // done
    'SSL.SSL': SSL.SSLConfig, // done
    'Cloud.Hosting': Mlytics.Vnis, // done
    'Mlytics.Vnis': Mlytics.Vnis, // done
    'Other.Standard': Other.Standard,
    'Server.Colocation': Mlytics.Vnis, // done
    'Domain.TLDs': Domain.TLDs, // done
    'Domain.VNNIC': Domain.VNNIC,
    'Server.VBM': Server.VBM, // done
    'Device.Liquidation': Server.VBM, // done
}

export default Template
